import MatchEvent from '../../../interfaces/matchEvent';

export default function getActiveMatchEvent(
  activeMatchEvents: MatchEvent[],
  main: boolean,
  sorting?: number,
  excludeIds?: number[],
  excludedMatchEventTypes?: number[],
  internalSorting?: number | null,
  matchEventTypeId?: number,
): MatchEvent | null {
  if (main) {
    const matchEvents = activeMatchEvents.filter((matchEvent) => matchEvent.internal?.mainEvent);
    if (matchEvents) {
      return matchEvents[0];
    }
  } else if (sorting) {
    const matchEvents = activeMatchEvents.filter((matchEvent) => {
      if (!matchEvent.internal?.mainEvent && matchEvent.sorting === sorting) {
        if (excludeIds && matchEvent.id) {
          if (excludedMatchEventTypes && excludedMatchEventTypes.indexOf(matchEvent.matchEventTypeId) > -1) {
            return false;
          }
          return excludeIds.indexOf(matchEvent.id) === -1;
        } else {
          return !(excludedMatchEventTypes && excludedMatchEventTypes.indexOf(matchEvent.matchEventTypeId) > -1);
        }
      }
      return false;
    });
    if (matchEvents && matchEvents[0]) {
      return matchEvents[0];
    }
  }

  if (internalSorting) {
    const matchEvents = activeMatchEvents.filter((matchEvent) => {
      if (
        !matchEvent.internal?.mainEvent &&
        matchEvent.internal?.sorting === internalSorting &&
        matchEvent.matchEventTypeId !== matchEventTypeId
      ) {
        if (excludeIds && matchEvent.id) {
          if (excludedMatchEventTypes && excludedMatchEventTypes.indexOf(matchEvent.matchEventTypeId) > -1) {
            return false;
          }
          return excludeIds.indexOf(matchEvent.id) === -1;
        } else {
          return !(excludedMatchEventTypes && excludedMatchEventTypes.indexOf(matchEvent.matchEventTypeId) > -1);
        }
      }
      return false;
    });
    if (matchEvents && matchEvents[0]) {
      return matchEvents[0];
    }
  }
  return null;
}
